import React from 'react';
import css from './Input.module.css';

const Input = React.forwardRef(({
  className = '',
  type = 'text',
  ...props
}, ref) => {
  return (
    <input
      ref={ref}
      type={type}
      className={`${css.input} ${className}`}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
